import RowInfo from "./RowInfo";
import RowButtons from "./RowButtons";
import RowActions from "./RowActions";
import { AdminListCard, AdminActions } from "../../../../SharedComponents/ListView";

export default function TestListRow({ test }) {
  return (
    <AdminListCard
      tag={test.tag}
      footer={
        <AdminActions className="justify-content-start">
          <RowActions test={test} />
        </AdminActions>
      }
    >
      <RowInfo test={test} />
      <AdminActions>
        <RowButtons test={test} />
      </AdminActions>
    </AdminListCard>
  );
}
